import Link from "next/link";

type Props = {
  id: string;
  name: string;
  link: string;
  startingPrice: string;
};

const NearYouCard = ({ link, id, name, startingPrice }: Props) => {
  const colors = [
    "#3D49BC",
    "#6635D2",
    "#DC3369",
    "#DF4545",
    "#9E44B5",
    "#6947C9",
  ];
  const randomColor = colors[Math.floor(Math.random() * colors.length)];
  return (
    <Link
      className={`w-full aspect-square rounded-[22px] hover:scale-[1.05] hover:shadow-xl transition-all`}
      style={{
        backgroundColor: randomColor,
      }}
      href={`/${link}`}
    >
      <div className="flex flex-col items-center justify-center w-full h-full py-[8px] px-[16px] text-white relative">
        <div className="flex flex-col justify-center h-full pb-5 -translate-y-2">
          <h5 className="text-[48px] font-[800]">{id}</h5>
        </div>
        <div className="absolute bottom-0 px-[16px] pb-[8px]">
          <p className="text-center text-[14px] font-[600]">
            {name
              .replace(/^place:/, "")
              .replace(/_/g, " ")
              .replace("International", "Intl")}
          </p>
          <p className="text-[12px] font-[300] text-center">
            Starting at <span className="font-bold">{startingPrice}</span>
          </p>
        </div>
      </div>
    </Link>
  );
};

export default NearYouCard;
